import { ContainerModule } from "inversify";
import { IndicadoresDITypes } from "./types";
import { IIndicadoresParams } from "@/core/composables/WidgetRequestFilter/types";
import IndicadoresParams from "@/core/composables/WidgetRequestFilter/IndicadoresParams";
import {
  EShortcutsDateIndicadores,
  IShortcutHandler
} from "@/core/composables/F360DateShortcuts/types";
import ShortcutIndicadoresHandler from "@/core/composables/F360DateShortcuts/ShortcutIndicadoresHandler";
import { IIndicadoresGateway } from "../services/ports/IndicadoresGateway";
import IndicadoreGatewayAdapter from "../services/adapters/IndicadoresGatewayAdapter";

const indicadoresContainer = new ContainerModule((bind) => {
  bind<IIndicadoresGateway>(IndicadoresDITypes.INDICADORES_GATEWAY).to(
    IndicadoreGatewayAdapter
  );
  bind<IIndicadoresParams>(IndicadoresDITypes.INDICADORES_PARAMS).to(
    IndicadoresParams
  );
  bind<IShortcutHandler<EShortcutsDateIndicadores>>(
    IndicadoresDITypes.SHORTCUT_INDICADORES_HANDLER
  )
    .to(ShortcutIndicadoresHandler)
    .inRequestScope();
});

export { indicadoresContainer };
